// extracted by mini-css-extract-plugin
module.exports = {"notes-modal":"notesModal_notes-modal__Sb2lf","notes-form":"notesModal_notes-form__6NLJj","textarea":"notesModal_textarea__1X0AM","close-btn":"notesModal_close-btn__gKrPl"};